module.exports = __webpack_public_path__ + "img/gzlb- 5.660bf480.jpg";